import type { DesignMode, MapTypeId } from 'types/studio/map'

export type AmplitudeProjectSurface = 'design' | 'proposal' | 'energy'

export type AmplitudeEventContext = {
  project_id?: number | string
  org_id?: number
  surface?: AmplitudeProjectSurface
  imagery_mode?: string
  design_mode?: DesignMode
}

/** Shared project / studio metadata for Amplitude event payloads. */
export const getAmplitudeEventContext = (surface?: AmplitudeProjectSurface): AmplitudeEventContext => {
  const state = window.reduxStore?.getState()
  const mapType = window.MapHelper?.activeMapInstance?.mapData?.mapType
  const project = window.WorkspaceHelper?.project
  const designMode = mapType ? window.MAP_TYPES?.[mapType as MapTypeId]?.designMode : undefined

  return {
    project_id: state?.projectId ?? project?.id,
    org_id: state?.auth?.org_id ?? project?.org_id,
    surface,
    imagery_mode: mapType,
    design_mode: designMode ?? undefined,
  }
}
